import React from "react";
import "./Password.css";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "../../UI/Button/Button";
import Input from "../../UI/Input/Input";
import FetchData from "../../../shared/fetchData";
import { updateObject, checkValidity } from "../../../shared/utility";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Done from "@material-ui/icons/Done";
import Close from "@material-ui/icons/Close";
import Fade from "react-reveal/Fade";
import DatePicker from "../../UI/DatePicker/DatePicker";

const Password = (props) => {
  const [registerDate, setRegisterDate] = React.useState("");
  const [invalidDate, setInvalidDate] = React.useState(false);

  const password = props.password;
  const [passwordTypes, setPasswordTypes] = React.useState([
    { value: "I", label: "رمز بارگزاری" },
    { value: "O", label: "رمز برداشت" },
    { value: "G", label: "رمز عمومی" },
    { value: "S", label: "رمز خاص" },
    { value: "FO", label: "رمز برداشت خارج از تایم رزرو"},
    { value: "FG", label: "رمز تخلیه خارج از تایم رزرو"}
  ]);
  const prmsn = window.localStorage.getItem("permission");
  const [message, setMessage] = React.useState({
    cellNumber: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شماره همراه",
      },
      validation: {
        required: true,
        isMobile: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
  });
  const [sendMessage, setSendMessage] = React.useState(false);
  const [messageSuccess, setMessageSuccess] = React.useState(false);
  const [hasSuccessMessage, setHasSuccessMessage] = React.useState(false);
  const [changeForm, setChangeForm] = React.useState(false);
  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(message, {
      [controlName]: updateObject(message[controlName], {
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          message[controlName].validation
        ),
      }),
    });
    setMessage(updatedControls);
  };
  const sendPasswordMessage = (event) => {
    let valid = true;
    const msg = message;
    if (msg.cellNumber.value == null || msg.cellNumber.value == "") {
      valid = false;
    }
    if (!valid) {
      msg.cellNumber.valid = false;
      setMessage(msg);
      if (changeForm) {
        setChangeForm(false);
      } else {
        setChangeForm(true);
      }
    } else {
      var raw = JSON.stringify({
        passwordId: password.id,
        cellNumber:
          message.cellNumber.value != ""
            ? message.cellNumber.value.toString().replace(/[^0-9]/g, "")
            : "",
        version: "mtpx001",
      });
      var url = "management/api/v1/passwords/sendPasswordMessage";
      FetchData(raw, url)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == 0) {
            setMessageSuccess(true);
            setHasSuccessMessage(true);
            setTimeout(() => {
              setMessageSuccess(false);
            }, 2000);
          }
        })
        .catch((error) => console.log(error));
    }
  };
  const registerDateChange = (unix, formatted) => {
    setRegisterDate(formatted);
  };
  const changeSendMessage = (event) => {
    setSendMessage(event.target.checked);
  };
  const passwordChangeState = (event) => {
    var raw = JSON.stringify({
      password: {
        id: password.id,
      },
      version: "mtpx001",
    });
    var url = "management/api/v1/passwords/changePasswordState";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          props.reloadPasswords();
        }
      })
      .catch((error) => console.log(error));
  };
  const formElementsArray = [];
  for (let key in message) {
    formElementsArray.push({
      id: key,
      config: message[key],
    });
  }
  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        col="4 p-0"
        className="pass-input"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });
  const btnText = !messageSuccess ? (
    hasSuccessMessage ? (
      <Fade>ارسال مجدد</Fade>
    ) : (
      <Fade>ارسال</Fade>
    )
  ) : (
    <Fade>
      <CheckCircleIcon />
    </Fade>
  );
  return (
    <div className="col-12">
      <div className="ord-pass-container">
        <div
          className={
            password.isActive == "1" ? "pass-content" : "deactive-pass-content"
          }
        >
          {password.content}
        </div>
        <div className="col-12">
          <div className="row w-100 justify-content-center mt-3 pb-2">
            {passwordTypes.map((p) => {
              return (
                <div className="col-3 full-small">
                  <label className="container role-text">
                    {p.label}
                    <input
                      type="checkbox"
                      checked={password.type != "" && password.type == p.value}
                      value="ENVELOPE"
                      id="flexCheckDefault"
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              );
            })}
          </div>
          <div className="row w-100 mt-2" dir="ltr">
            <div
              className={[
                "col-3 full-small",
                password.isActive == "0" ? "disable-div" : "",
              ].join(" ")}
            >
              {prmsn.split(",").includes("CUSTOMER_WRITE") ? (
                ""
              ) : (
                <Button btnType="General" clicked={passwordChangeState}>
                  غیر فعال کردن
                </Button>
              )}
            </div>
          </div>
        </div>
        <hr className="pass-line" />
        <div className="row w-100 justify-content-center ml-0 mr-0">
          <div className="col-3 p-0 full-small">
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    password.needPayment != null &&
                    password.needPayment != "" &&
                    password.needPayment == "1"
                  }
                />
              }
              label="نیاز به پرداخت دارد"
            />
          </div>
          <div className="col-3 p-0 full-small">
            <DatePicker
              className={
                invalidDate && (registerDate == null || registerDate == "")
                  ? "invalid-date"
                  : ""
              }
              change={registerDateChange}
              col="6 mt-2 hulf-small"
              value={registerDate}
              placeHolder="تاریخ ثبت"
            ></DatePicker>
          </div>

          {password.needPayment != null &&
          password.needPayment != "" &&
          password.needPayment == "1" ? (
            <div className="col-3 mt-3 full-small">
              {password.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
              ريال
            </div>
          ) : (
            <div className="col-3 mt-3 full-small"></div>
          )}
          <div className="col-6 mt-3 full-small">
            {password.isOpen != null &&
            password.isOpen != "" &&
            password.isOpen == "1" ? (
              <span>
                <Done className="pass-icon" /> رمز باز شده است{" "}
              </span>
            ) : (
              <span>
                <Close className="pass-icon" /> رمز باز نشده است
              </span>
            )}
          </div>
          <div className="row w-100 justify-content-center ml-0 mr-0">
            <div className="col-6 mt-3 pr-3 full-small">
              <span>تاریخ انقضا: {password.expireDate}</span>
            </div>
            <div className="col-6 mt-3 pr-3 full-small">
              <span>ساعت انقضا: {password.expireTime}</span>
            </div>
          </div>
        </div>
        <hr className="pass-line" />
        {prmsn.split(",").includes("CUSTOMER_WRITE") ? (
          ""
        ) : (
          <div className="row w-100 justify-content-center pt-3">
            <div
              className={sendMessage ? "col-5 full-small" : "col-10 full-small"}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendMessage}
                    onChange={changeSendMessage}
                  />
                }
                label="آیا مایل به ارسال پیامک هستید؟"
              />
            </div>
            {sendMessage ? form : ""}
            {sendMessage ? (
              <div className="col-1 text-center p-0">
                <Button
                  className="pass-sms-btn"
                  btnType="Success"
                  clicked={sendPasswordMessage}
                >
                  {btnText}
                </Button>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Password;
